require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./checkbox"), require("./collapse"), require("./combobox"), require("./container"), require("./label"), require("./numberinput"), require("./radiogroup"), require("./select"), require("./selectgroup"), require("./svgicon"), require("./textarea"), require("./textinput"), require("./toggleswitch"), require("./tooltip"), require("./truncatedtext"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./checkbox", "./collapse", "./combobox", "./container", "./label", "./numberinput", "./radiogroup", "./select", "./selectgroup", "./svgicon", "./textarea", "./textinput", "./toggleswitch", "./tooltip", "./truncatedtext", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./checkbox"), require("./collapse"), require("./combobox"), require("./container"), require("./label"), require("./numberinput"), require("./radiogroup"), require("./select"), require("./selectgroup"), require("./svgicon"), require("./textarea"), require("./textinput"), require("./toggleswitch"), require("./tooltip"), require("./truncatedtext"), require("./utils")) : factory(root["./button"], root["./checkbox"], root["./collapse"], root["./combobox"], root["./container"], root["./label"], root["./numberinput"], root["./radiogroup"], root["./select"], root["./selectgroup"], root["./svgicon"], root["./textarea"], root["./textinput"], root["./toggleswitch"], root["./tooltip"], root["./truncatedtext"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__28432__, __WEBPACK_EXTERNAL_MODULE__48477__, __WEBPACK_EXTERNAL_MODULE__56006__, __WEBPACK_EXTERNAL_MODULE__32299__, __WEBPACK_EXTERNAL_MODULE__37394__, __WEBPACK_EXTERNAL_MODULE__11880__, __WEBPACK_EXTERNAL_MODULE__46061__, __WEBPACK_EXTERNAL_MODULE__16414__, __WEBPACK_EXTERNAL_MODULE__15294__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__90230__, __WEBPACK_EXTERNAL_MODULE__73346__, __WEBPACK_EXTERNAL_MODULE__58083__, __WEBPACK_EXTERNAL_MODULE__65391__, __WEBPACK_EXTERNAL_MODULE__47511__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[411],{

/***/ 65735:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _reactResizable = __webpack_require__(95103);
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _resizePanel_ = _interopRequireDefault(__webpack_require__(3591));
var _Container = _interopRequireDefault(__webpack_require__(11608));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  sizeArrayToCss,
  mergeStyles
} = _utils.cssUtils;
const {
  sanitize
} = _utils.propsUtils;
const {
  isKey,
  keyNames
} = _utils.keyboardUtils;
const containerClassName = _Container.default.containerClassName.replace(/"/g, '');
const KB_RESIZE_STEP = 5;
class Container extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_onResize", (event, data) => {
      this.setState({
        width: data.size.width,
        height: data.size.height
      });
      this.props.onResize(event, data);
    });
    (0, _defineProperty2.default)(this, "_handler", h => /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      "aria-label": "resizable-container__handler",
      "data-tid": "ba-common-resizable-container__handler",
      className: `resize-handler-icon resize-handler-icon-${h}`,
      tabIndex: "0",
      onKeyDown: this._onResizeHandlerKeyDown,
      iconId: _resizePanel_.default.id
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: `react-resizable-handle react-resizable-handle-${h}`
    })));
    (0, _defineProperty2.default)(this, "_onResizeHandlerKeyDown", e => {
      const {
        LEFT,
        RIGHT,
        UP,
        DOWN
      } = keyNames;
      const {
        resizeDirection,
        resizeMinConstraintsX,
        resizeMaxConstraintsX,
        resizeMinConstraintsY,
        resizeMaxConstraintsY
      } = this.props;
      const {
        width,
        height
      } = this.state;
      if (isKey(e, LEFT) || isKey(e, RIGHT) || isKey(e, UP) || isKey(e, DOWN)) {
        if (resizeDirection === 'x') {
          if (isKey(e, LEFT) && resizeMinConstraintsX <= width - KB_RESIZE_STEP) {
            this.setState({
              width: width - KB_RESIZE_STEP
            });
          } else if (isKey(e, RIGHT) && resizeMaxConstraintsX >= width + KB_RESIZE_STEP) {
            this.setState({
              width: width + KB_RESIZE_STEP
            });
          }
        } else if (resizeDirection === 'y') {
          if (isKey(e, UP) && resizeMinConstraintsY <= height - KB_RESIZE_STEP) {
            this.setState({
              height: height - KB_RESIZE_STEP
            });
          } else if (isKey(e, DOWN) && resizeMaxConstraintsY >= height + KB_RESIZE_STEP) {
            this.setState({
              height: height + KB_RESIZE_STEP
            });
          }
        }
        e.preventDefault();
      }
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;
    });
    this.state = {
      width: 0,
      height: 0
    };
  }
  componentDidMount() {
    const {
      resizable
    } = this.props;
    if (resizable) {
      this.setState({
        height: this._node.offsetHeight,
        width: this._node.offsetWidth
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      resizable
    } = this.props;
    if (resizable && (prevState.height !== this._node.offsetHeight || prevState.width !== this._node.offsetWidth)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        height: this._node.offsetHeight,
        width: this._node.offsetWidth
      });
    }
  }
  render() {
    const {
      children,
      gutter,
      margin,
      padding,
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      overflow,
      relative,
      textAlign,
      style,
      resizable,
      resizeDirection,
      resizeMinConstraintsX,
      resizeMinConstraintsY,
      resizeMaxConstraintsX,
      resizeMaxConstraintsY,
      className,
      onResizeStart,
      onResizeStop,
      id,
      isPassive,
      resizeHandles,
      ...others
    } = this.props;
    const styles = mergeStyles(style, {
      overflow,
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      textAlign,
      margin: sizeArrayToCss(margin),
      padding: sizeArrayToCss(gutter || padding)
    });
    if (relative) {
      styles.position = 'relative';
    }
    const adjustedWidth = this.state.width === 0 ? this.props.width : this.props.isPassive ? this.props.width : this.state.width;
    const adjustedHeight = this.state.height === 0 ? this.props.height : this.props.isPassive ? this.props.height : this.state.height;
    const classNames = (0, _utils.classnames)(containerClassName);
    const containerComponentClass = `${classNames} ${className}`;
    let defaultResizeHandles;
    if (resizable) {
      if (resizeHandles === undefined) {
        switch (resizeDirection) {
          case 'x':
            defaultResizeHandles = ['e'];
            break;
          case 'y':
            defaultResizeHandles = ['s'];
            break;
          case 'both':
            defaultResizeHandles = ['se'];
            break;
          default:
        }
      }
      return /*#__PURE__*/_react.default.createElement(_reactResizable.Resizable, (0, _extends2.default)({}, sanitize(others, Container), {
        axis: resizeDirection
        // BAUICOMMON-803 Expression editor window fix
        // if the browser is being resized then pass props.width and props.height to respect browser size
        ,
        height: isPassive ? height : this.state.height,
        width: isPassive ? width : this.state.width,
        onResize: this._onResize,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        minConstraints: [resizeMinConstraintsX, resizeMinConstraintsY],
        maxConstraints: [resizeMaxConstraintsX, resizeMaxConstraintsY],
        resizeHandles: resizeHandles === undefined ? defaultResizeHandles : resizeHandles,
        handle: this._handler
      }), /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        className: (0, _utils.classnames)(containerComponentClass, resizeDirection),
        style: {
          ...styles,
          // BAUICOMMON-803 Expression editor window fix
          // if the browser is being resized then pass props.width and props.height to respect browser size
          width: adjustedWidth,
          height: adjustedHeight
        },
        ref: this._ref
      }, children));
    }
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      id: id,
      className: containerComponentClass,
      ref: this._ref
    }, sanitize(others, Container), {
      style: styles
    }), children);
  }
}
exports["default"] = Container;
(0, _defineProperty2.default)(Container, "propTypes", {
  gutter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  margin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  overflow: _propTypes.default.string,
  relative: _propTypes.default.bool,
  children: _propTypes.default.node,
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  style: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  resizable: _propTypes.default.bool,
  resizeDirection: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
  resizeMinConstraintsX: _propTypes.default.number,
  resizeMinConstraintsY: _propTypes.default.number,
  resizeMaxConstraintsX: _propTypes.default.number,
  resizeMaxConstraintsY: _propTypes.default.number,
  onResize: _propTypes.default.func,
  onResizeStart: _propTypes.default.func,
  onResizeStop: _propTypes.default.func,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  resizeHandles: _propTypes.default.array,
  isPassive: _propTypes.default.bool // to allow caller control the size by width and height props
});
(0, _defineProperty2.default)(Container, "defaultProps", {
  resizable: false,
  resizeDirection: 'x',
  className: '',
  style: {},
  resizeMinConstraintsX: 32,
  resizeMinConstraintsY: 32,
  resizeMaxConstraintsX: Number.POSITIVE_INFINITY,
  resizeMaxConstraintsY: Number.POSITIVE_INFINITY,
  onResize: () => {},
  onResizeStart: () => {},
  onResizeStop: () => {}
});

/***/ }),

/***/ 64562:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _container = _interopRequireDefault(__webpack_require__(32299));
var _label = _interopRequireDefault(__webpack_require__(37394));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(71379));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

// TODO build out clickRelay component?
// import ClickRelay from '../controls/ClickRelay';
const propertiesPaneClassName = _PropertiesPane.default.propertiesPaneClassName.replace(/"/g, '');
const {
  sanitize,
  BaPropTypes
} = _utils.propsUtils;
class PropertiesPane extends _react.Component {
  _onClick(labelAction) {
    return e => {
      labelAction && e.preventDefault();
    };
  }
  _isLabelAction() {
    const {
      children
    } = this.props;
    let labelAction;
    let child;
    try {
      child = _react.default.Children.only(children).type;
      // prevent dropdown focusing on label click
      // eslint-disable-next-line no-underscore-dangle
      labelAction = child.__Select__ || child.__ComboBox__ || child.__SelectGroup__ || false;
    } catch (err) {
      labelAction = false;
    }
    return labelAction;
  }
  render() {
    const {
      icon,
      label,
      htmlFor,
      labelId,
      disabled,
      rtl,
      dataLabel,
      children,
      childrenAlignEnd,
      className,
      style,
      labelStyle,
      labelSize,
      validationNode,
      descriptionNode,
      changeIndicatorNode,
      ...others
    } = this.props;
    const isColumn = labelSize === 'full';
    const labelAction = this._isLabelAction();
    let iconComponent;
    const iconType = typeof icon;
    if (iconType !== 'undefined') {
      // will be deprecated
      iconComponent = /*#__PURE__*/_react.default.createElement("span", {
        className: `${propertiesPaneClassName}__iconPosition`
      }, iconType === 'string' ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        className: (0, _utils.classnames)(`${propertiesPaneClassName}__icon`),
        disabled: disabled,
        iconId: icon,
        size: "small"
      }) : icon);
    }
    let labelContent = /*#__PURE__*/_react.default.createElement("div", {
      className: `${propertiesPaneClassName}__labelContent ${(0, _utils.classnames)({
        rtl
      })}`
    }, iconComponent, typeof label === 'string' ? /*#__PURE__*/_react.default.createElement(_label.default, {
      onClick: this._onClick(labelAction),
      htmlFor: htmlFor,
      label: label,
      disabled: disabled,
      ellipsis: dataLabel,
      style: labelStyle
    }) : label);
    if (validationNode || descriptionNode || changeIndicatorNode) {
      labelContent = /*#__PURE__*/_react.default.createElement("div", {
        className: `${propertiesPaneClassName}__labelContent ${(0, _utils.classnames)({
          rtl
        })}`
      }, validationNode, descriptionNode, typeof label === 'string' ? /*#__PURE__*/_react.default.createElement(_label.default, {
        onClick: this._onClick(labelAction),
        htmlFor: htmlFor,
        label: label,
        disabled: disabled,
        ellipsis: dataLabel,
        style: labelStyle
      }) : label, changeIndicatorNode);
    }
    const classNames = (0, _utils.classnames)(propertiesPaneClassName, {
      rtl
    });
    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, PropertiesPane), {
      padding: [0, 0],
      className: `${classNames} ${className}`,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_container.default, {
      className: (0, _utils.classnames)(`${propertiesPaneClassName}__inner`, labelSize, isColumn ? 'column' : '')
    }, /*#__PURE__*/_react.default.createElement(_container.default, {
      className: (0, _utils.classnames)(`${propertiesPaneClassName}__label`),
      id: labelId
    }, labelContent), /*#__PURE__*/_react.default.createElement(_container.default, {
      className: (0, _utils.classnames)(`${propertiesPaneClassName}__children`, {
        flexEnd: childrenAlignEnd
      })
    }, children)));
  }
}
exports["default"] = PropertiesPane;
(0, _defineProperty2.default)(PropertiesPane, "propTypes", {
  icon: BaPropTypes.deprecated('It will be removed soon, use "validationRenderer", "descriptionRenderer", "changeRenderer" instead'),
  validationNode: _propTypes.default.node,
  descriptionNode: _propTypes.default.node,
  changeIndicatorNode: _propTypes.default.node,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  htmlFor: _propTypes.default.string,
  className: _propTypes.default.string,
  labelId: _propTypes.default.string,
  style: _propTypes.default.object,
  labelStyle: _propTypes.default.object,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  dataLabel: _propTypes.default.bool,
  children: _propTypes.default.node,
  childrenAlignEnd: _propTypes.default.bool
});
(0, _defineProperty2.default)(PropertiesPane, "defaultProps", {
  labelSize: 'medium',
  className: '',
  style: {},
  labelStyle: {}
});

/***/ }),

/***/ 34555:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _container = _interopRequireDefault(__webpack_require__(32299));
var _label = _interopRequireDefault(__webpack_require__(37394));
var _utils = __webpack_require__(78815);
var _PropertyPanel = _interopRequireDefault(__webpack_require__(35486));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const propertyPanelClassName = _PropertyPanel.default.propertyPanelClassName.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;
class PropertyPanel extends _react.Component {
  render() {
    const {
      title,
      className,
      isResizable,
      children,
      buttons,
      style,
      ...others
    } = this.props;
    const titleSection = /*#__PURE__*/_react.default.createElement(_label.default, {
      "data-tid": "ba-common-property-panel__title-section",
      className: `${propertyPanelClassName}__panelTitle`,
      label: title
    });
    const childrenContent = /*#__PURE__*/_react.default.createElement(_container.default, {
      "data-tid": "ba-common-property-panel__content-section"
    }, children);
    const buttonsSection = buttons ? /*#__PURE__*/_react.default.createElement(_container.default, {
      "data-tid": "ba-common-property-panel__button-section",
      className: `${propertyPanelClassName}__buttonSection`
    }, buttons) : '';
    const classNames = (0, _utils.classnames)(propertyPanelClassName);
    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, PropertyPanel), {
      className: `${classNames} ${className}`,
      resizable: isResizable,
      style: style
    }), titleSection, childrenContent, buttonsSection);
  }
}
exports["default"] = PropertyPanel;
(0, _defineProperty2.default)(PropertyPanel, "propTypes", {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  className: _propTypes.default.string,
  // children:
  // Tabs -> TabPanels -> PropertySections
  // PropertySections
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]),
  buttons: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]),
  rtl: _propTypes.default.bool,
  isResizable: _propTypes.default.bool,
  style: _propTypes.default.object
});
(0, _defineProperty2.default)(PropertyPanel, "defaultProps", {
  className: '',
  style: {},
  title: ''
});

/***/ }),

/***/ 50339:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
exports["default"] = _PropertiesPane.default;
exports.PropertiesPane = _PropertiesPane.default;
var _PropertyPanel = _interopRequireDefault(__webpack_require__(34555));
exports.PropertyPanel = _PropertyPanel.default;
var _TextSection = _interopRequireDefault(__webpack_require__(37955));
exports.TextSection = _TextSection.default;
var _CheckboxSection = _interopRequireDefault(__webpack_require__(68118));
exports.CheckboxSection = _CheckboxSection.default;
var _ComboboxSection = _interopRequireDefault(__webpack_require__(18128));
exports.ComboboxSection = _ComboboxSection.default;
var _ToggleSwitchSection = _interopRequireDefault(__webpack_require__(53784));
exports.ToggleSwitchSection = _ToggleSwitchSection.default;
var _RadioSection = _interopRequireDefault(__webpack_require__(59573));
exports.RadioSection = _RadioSection.default;
var _SelectSection = _interopRequireDefault(__webpack_require__(572));
exports.SelectSection = _SelectSection.default;
var _MultiSelectSection = _interopRequireDefault(__webpack_require__(97981));
exports.MultiSelectSection = _MultiSelectSection.default;
var _TextAreaSection = _interopRequireDefault(__webpack_require__(99578));
exports.TextAreaSection = _TextAreaSection.default;
var _TextInputSection = _interopRequireDefault(__webpack_require__(13526));
exports.TextInputSection = _TextInputSection.default;
var _NumberInputSection = _interopRequireDefault(__webpack_require__(31662));
exports.NumberInputSection = _NumberInputSection.default;
var _CollapsibleSection = _interopRequireDefault(__webpack_require__(93345));
exports.CollapsibleSection = _CollapsibleSection.default;
var _LabelSection = _interopRequireDefault(__webpack_require__(39982));
exports.LabelSection = _LabelSection.default;
var _LinkSection = _interopRequireDefault(__webpack_require__(8972));
exports.LinkSection = _LinkSection.default;

/***/ }),

/***/ 68118:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _checkbox = _interopRequireDefault(__webpack_require__(28432));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const checkboxSectionClassName = _SectionStyles.default.checkboxSectionClassName.replace(/"/g, '');
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps,
  BaPropTypes
} = _utils.propsUtils;
class CheckboxSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__checkboxSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      label,
      title,
      checked,
      indeterminate,
      disabled,
      readOnly,
      rtl,
      onChange,
      labelSize,
      className,
      style,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: checkboxPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    const checkbox = /*#__PURE__*/_react.default.createElement(_checkbox.default, (0, _extends2.default)({}, checkboxPassthroughProps, {
      "data-tid": `ba-common-checkbox-section__${this._id}-checkbox`,
      align: rtl ? 'right' : 'left',
      checked: checked,
      indeterminate: indeterminate,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      id: this._id,
      "aria-labelledby": this._propLabelId
    }));
    const classnames = (0, _utils.classnames)(checkboxSectionClassName);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, CheckboxSection), propertiesPanePassthroughProps, {
      className: `${classnames} ${className}`,
      label: label,
      title: title,
      labelSize: labelSize,
      labelId: this._propLabelId,
      disabled: disabled,
      htmlFor: this._id,
      rtl: rtl,
      style: style
    }), checkbox);
  }
}
exports["default"] = CheckboxSection;
(0, _defineProperty2.default)(CheckboxSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  checked: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._checkbox.default.propTypes,
  ..._PropertiesPane.default.propTypes,
  labelSize: BaPropTypes.deprecated('It will be removed soon, Checkbox width is non-negotiable')
});
(0, _defineProperty2.default)(CheckboxSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 93345:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _button = _interopRequireDefault(__webpack_require__(32477));
var _collapse = _interopRequireDefault(__webpack_require__(48477));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _chevronRight_ = _interopRequireDefault(__webpack_require__(37592));
var _container = _interopRequireDefault(__webpack_require__(32299));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const collapsibleSectionClassName = _SectionStyles.default.collapsibleSectionClassName.replace(/"/g, ''); // eslint-disable-line no-unused-vars

const {
  uniqueId,
  omit
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
const {
  getKeyName,
  keyNames
} = _utils.keyboardUtils;
class CollapsibleSection extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_toggleOpen", () => {
      const {
        open,
        onOpen
      } = this.props;
      if (typeof open === 'undefined') {
        this.setState(state => ({
          open: !state.open
        }));
      }
      onOpen && onOpen(!open);
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      const {
        open
      } = this.state;
      switch (getKeyName(e)) {
        case keyNames.LEFT:
        case keyNames.UP:
          e.preventDefault();
          if (open) {
            this._toggleOpen();
          }
          break;
        case keyNames.RIGHT:
        case keyNames.DOWN:
          e.preventDefault();
          if (!open) {
            this._toggleOpen();
          }
          break;
        default:
      }
    });
    this.state = {
      open: !!this.props.defaultOpen || !!this.props.open
    };
    this._id = uniqueId('__collapsibleSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  componentWillReceiveProps(_ref) {
    let {
      open
    } = _ref;
    if (open != null && open !== this.state.open) {
      this.setState({
        open
      });
    }
  }
  render() {
    const {
      label,
      title,
      rtl,
      variant,
      children,
      className,
      style,
      labelStyle,
      autoUnmount,
      ...others
    } = this.props;
    const {
      open
    } = this.state;
    const regionId = `${this._id}_region`;
    const {
      propertiesPanePassthroughProps,
      others: theRest
    } = getPassThroughProps(others, _PropertiesPane.default);
    const {
      collapsePassthroughProps,
      others: buttonPassthoughProps
    } = getPassThroughProps(theRest, _collapse.default);
    const labelNode = /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, buttonPassthoughProps, {
      className: `${collapsibleSectionClassName}__trigger-button`,
      "data-tid": "ba-common-collapse-section__trigger-button",
      id: this._id,
      kind: "ghost",
      size: "field",
      renderIcon: props => /*#__PURE__*/_react.default.createElement(_svgicon.default, (0, _extends2.default)({
        icon: _chevronRight_.default,
        rotate: open ? -90 : 90
      }, props)),
      onClick: this._toggleOpen,
      onKeyDown: this._onKeyDown,
      "aria-controls": regionId,
      "aria-expanded": open,
      "aria-labelledby": this._propLabelId,
      style: labelStyle
    }), label);
    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, CollapsibleSection), {
      className: `ba-common-collapsibleSection ${className}`,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, propertiesPanePassthroughProps, {
      label: labelNode,
      title: title,
      rtl: rtl,
      htmlFor: this._id,
      labelSize: "full",
      labelId: this._propLabelId,
      variant: variant
    })), /*#__PURE__*/_react.default.createElement(_collapse.default, (0, _extends2.default)({}, collapsePassthroughProps, {
      autoUnmount: autoUnmount,
      isOpened: open,
      id: regionId
    }), children));
  }
}
exports["default"] = CollapsibleSection;
(0, _defineProperty2.default)(CollapsibleSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  title: _propTypes.default.string,
  defaultOpen: _propTypes.default.bool,
  open: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['normal', 'header']),
  onOpen: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  labelStyle: _propTypes.default.object,
  autoUnmount: _propTypes.default.bool,
  ...omit(_collapse.default.propTypes, 'isOpened')
});
(0, _defineProperty2.default)(CollapsibleSection, "defaultProps", {
  variant: 'normal',
  className: '',
  style: {},
  labelStyle: {}
});

/***/ }),

/***/ 18128:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _combobox = _interopRequireDefault(__webpack_require__(56006));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const comboboxSectionClassName = _SectionStyles.default.comboboxSectionClassName.replace(/"/g, '');
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
class ComboboxSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__ComboboxSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      label,
      title,
      labelSize,
      disabled,
      rtl,
      className,
      style,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: comboBoxPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, ComboboxSection), propertiesPanePassthroughProps, {
      className: `${comboboxSectionClassName} ${className}`,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      label: label,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_combobox.default, (0, _extends2.default)({}, comboBoxPassthroughProps, {
      id: this._id,
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-combox-section__combox",
      disabled: disabled
    })));
  }
}
exports["default"] = ComboboxSection;
(0, _defineProperty2.default)(ComboboxSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._combobox.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(ComboboxSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 39982:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _label = _interopRequireDefault(__webpack_require__(37394));
var _container = _interopRequireDefault(__webpack_require__(32299));
var _utils = __webpack_require__(78815);
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const labelSectionClassName = _SectionStyles.default.labelSectionClassName.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;
class LabelSection extends _react.Component {
  render() {
    const {
      label,
      rtl,
      isSectionHeader,
      disabled,
      className,
      style,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(labelSectionClassName, isSectionHeader ? 'sectionHeader' : '');
    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({
      className: `${classNames} ${className}`,
      textAlign: rtl ? 'left' : 'right',
      style: style
    }, sanitize(others, LabelSection)), /*#__PURE__*/_react.default.createElement(_label.default, (0, _extends2.default)({}, others, {
      label: label,
      disabled: disabled
    })));
  }
}
exports["default"] = LabelSection;
(0, _defineProperty2.default)(LabelSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  isSectionHeader: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._label.default.propTypes
});
(0, _defineProperty2.default)(LabelSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 8972:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _button = _interopRequireDefault(__webpack_require__(32477));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _chevronRight_ = _interopRequireDefault(__webpack_require__(68946));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const linkSectionClassName = _SectionStyles.default.linkSectionClassName.replace(/"/g, '');
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
class LinkSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__linkSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      label,
      value,
      title,
      disabled,
      rtl,
      dataLabel,
      onClick,
      labelSize,
      className,
      style,
      ...others
    } = this.props;
    const buttonIcon = {
      [rtl ? 'iconLeft' : 'iconRight']: rtl ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        focusable: false,
        iconId: _chevronRight_.default.id,
        rotate: 180
      }) : /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        focusable: false,
        iconId: _chevronRight_.default.id
      })
    };
    const {
      propertiesPanePassthroughProps,
      others: buttonPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, LinkSection), propertiesPanePassthroughProps, {
      className: `${linkSectionClassName} ${className}`,
      label: label,
      rtl: rtl,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      dataLabel: dataLabel,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_button.default
    // {...buttonPassThroughProps}}// TODO: uncomment this line and remove next line when icon is deprecated
    , (0, _extends2.default)({}, sanitize(buttonPassthroughProps, null, 'icon'), buttonIcon, {
      role: "link",
      "data-tid": "ba-common-link-section__button-link",
      "aria-label": title,
      intent: "primary",
      ellipsis: true,
      id: this._id,
      variant: "inline",
      label: value,
      disabled: disabled,
      onClick: onClick,
      title: title,
      "aria-labelledby": title ? null : this._propLabelId
    })));
  }
}
exports["default"] = LinkSection;
(0, _defineProperty2.default)(LinkSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  title: _propTypes.default.string,
  // todo
  // currently title is used for the title of the link
  // we may need two titles - one for the property, and one for the link

  disabled: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  dataLabel: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._button.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(LinkSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 97981:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _selectgroup = _interopRequireDefault(__webpack_require__(15294));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const selectSectionClassName = _SectionStyles.default.selectSectionClassName.replace(/"/g, '');
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
class SelectGroupSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__multiSelectSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      options,
      label,
      title,
      selected,
      disabled,
      readOnly,
      rtl,
      onChange,
      labelSize,
      className,
      style,
      light,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: selectGroupPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, SelectGroupSection), propertiesPanePassthroughProps, {
      className: `${selectSectionClassName} ${className}`,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_selectgroup.default, (0, _extends2.default)({}, sanitize(selectGroupPassthroughProps, null, 'icon'), {
      // {...selectGroupPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated
      "data-tid": "ba-common-select-group-section__select-group",
      "aria-labelledby": this._propLabelId,
      lastId: this._id,
      size: "small",
      align: rtl ? 'left' : 'right',
      orient: rtl ? 'bottom-right' : 'bottom-left',
      selected: selected,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      options: options,
      light: light != null ? light : true
    })));
  }
}
exports["default"] = SelectGroupSection;
(0, _defineProperty2.default)(SelectGroupSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  options: _propTypes.default.object.isRequired,
  selected: _propTypes.default.array.isRequired,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._selectgroup.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(SelectGroupSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 31662:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _numberinput = _interopRequireDefault(__webpack_require__(11880));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const numberInputSectionClassName = _SectionStyles.default.numberInputSectionClassName.replace(/"/g, '');
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
class NumberInputSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__numberInputSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      title,
      light,
      disabled,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: numberInputPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    const inputProps = {
      id: this._id,
      fullWidth: true
    };
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, propertiesPanePassthroughProps, {
      title: title,
      htmlFor: this._id,
      labelId: this._propLabelId,
      className: `${numberInputSectionClassName}`,
      disabled: disabled
    }), /*#__PURE__*/_react.default.createElement(_numberinput.default
    // {...numberInputPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated
    , (0, _extends2.default)({}, sanitize(numberInputPassthroughProps, null, 'icon'), inputProps, {
      "data-tid": "ba-common-numberinput-section__numberinput",
      "aria-labelledby": this._propLabelId,
      className: "numberInputSection",
      light: light != null ? light : true,
      disabled: disabled
    })));
  }
}
exports["default"] = NumberInputSection;
(0, _defineProperty2.default)(NumberInputSection, "propTypes", {
  title: _propTypes.default.string,
  ...sanitize(_numberinput.default.propTypes, null, 'fullWidth'),
  ..._PropertiesPane.default.propTypes
});

/***/ }),

/***/ 59573:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _radiogroup = _interopRequireDefault(__webpack_require__(46061));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const radioSectionClassName = _SectionStyles.default.radioSectionClassName.replace(/"/g, '');
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
class RadioSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__radioSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      label,
      title,
      checked,
      disabled,
      readOnly,
      rtl,
      options,
      onChange,
      labelSize,
      className,
      style,
      ...others
    } = this.props;
    const align = this.props.align || rtl ? 'right' : 'left';
    const {
      propertiesPanePassthroughProps,
      others: radioGroupPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others), propertiesPanePassthroughProps, {
      className: `${radioSectionClassName} ${className}`,
      labelSize: labelSize,
      label: label,
      title: title,
      disabled: disabled,
      rtl: rtl,
      htmlFor: this._id,
      labelId: this._propLabelId,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_radiogroup.default, (0, _extends2.default)({}, radioGroupPassthroughProps, {
      "data-tid": "ba-common-radio-section__radio-group",
      "aria-labelledby": this._propLabelId,
      selectedId: this._id,
      direction: "vertical",
      align: align,
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      options: options
    })));
  }
}
exports["default"] = RadioSection;
(0, _defineProperty2.default)(RadioSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  align: _propTypes.default.oneOf(['left', 'right']),
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  options: _propTypes.default.array.isRequired,
  checked: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._radiogroup.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(RadioSection, "defaultProps", {
  labelSize: 'full',
  className: '',
  style: {}
});

/***/ }),

/***/ 572:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _select = _interopRequireDefault(__webpack_require__(16414));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const selectSectionClassName = _SectionStyles.default.selectSectionClassName.replace(/"/g, '');
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
class SelectSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__selectSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      label,
      title,
      selected,
      options,
      disabled,
      rtl,
      textDir,
      onChange,
      readOnly,
      labelSize,
      displayLabel,
      className,
      style,
      light,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: selectPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, SelectSection), propertiesPanePassthroughProps, {
      className: `${selectSectionClassName} ${className}`,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_select.default, (0, _extends2.default)({}, sanitize(selectPassthroughProps, null, 'icon'), {
      // {...selectPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated
      "data-tid": "ba-common-select-section__select",
      "aria-labelledby": this._propLabelId,
      size: "small",
      id: this._id,
      selected: selected,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      displayLabel: displayLabel,
      options: options,
      textDir: textDir,
      light: light != null ? light : true
    })));
  }
}
exports["default"] = SelectSection;
(0, _defineProperty2.default)(SelectSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  displayLabel: _propTypes.default.string,
  // Used for empty placeholder state of select. Will not be shown if passed a Selected prop
  title: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  // CSS Grid layout 1/4, 1/2, 3/4, full widths
  selected: _propTypes.default.any.isRequired,
  options: _propTypes.default.array.isRequired,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  onChange: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._select.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(SelectSection, "defaultProps", {
  className: '',
  style: {},
  selected: []
});

/***/ }),

/***/ 99578:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _information_ = _interopRequireDefault(__webpack_require__(21149));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _textarea = _interopRequireDefault(__webpack_require__(90230));
var _tooltip = _interopRequireDefault(__webpack_require__(65391));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
const textAreaSectionClassName = _SectionStyles.default.textAreaSectionClassName.replace(/"/g, ''); // eslint-disable-line no-unused-vars

class TextAreaSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__textAreaSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      label,
      tooltipText,
      title,
      placeholder,
      rows,
      value,
      disabled,
      rtl,
      fireOnBlur,
      onChange,
      readOnly,
      className,
      labelSize,
      style,
      light,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(textAreaSectionClassName);
    const {
      propertiesPanePassthroughProps,
      others: textAreaPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, TextAreaSection), propertiesPanePassthroughProps, {
      className: `${classNames} ${className}`,
      label: label,
      title: title,
      disabled: disabled,
      labelSize: labelSize,
      htmlFor: this._id,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), tooltipText && /*#__PURE__*/_react.default.createElement("div", {
      className: "tooltip-position"
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: tooltipText,
      orient: "left"
    }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      icon: _information_.default.id
    }))), /*#__PURE__*/_react.default.createElement(_textarea.default, (0, _extends2.default)({}, textAreaPassthroughProps, {
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-textarea-section__textarea",
      id: this._id,
      value: value,
      rows: rows,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      placeholder: placeholder,
      fireOnBlur: fireOnBlur,
      light: light != null ? light : true
    })));
  }
}
exports["default"] = TextAreaSection;
(0, _defineProperty2.default)(TextAreaSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  className: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  tooltipText: _propTypes.default.string,
  rows: _propTypes.default.number,
  fireOnBlur: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  style: _propTypes.default.object,
  ..._textarea.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(TextAreaSection, "defaultProps", {
  labelSize: 'full',
  className: '',
  style: {}
});

/***/ }),

/***/ 13526:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _textinput = _interopRequireDefault(__webpack_require__(73346));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const textInputSectionClassName = _SectionStyles.default.textInputSectionClassName.replace(/"/g, '');
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
class TextInputSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__textInputSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      'data-tid': dataTid,
      label,
      title,
      placeholder,
      value,
      textAlign,
      disabled,
      rtl,
      fireOnBlur,
      onChange,
      readOnly,
      labelSize,
      className,
      style,
      textDir,
      light,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: textInputPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    const inputProps = {
      id: this._id,
      fullWidth: true,
      textAlign,
      placeholder,
      value,
      onChange,
      disabled,
      readOnly,
      fireOnBlur
    };
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, TextInputSection), propertiesPanePassthroughProps, {
      "data-tid": dataTid,
      className: `${textInputSectionClassName} ${className}`,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_textinput.default
    // {...textInputPassthroughProps}// TODO: uncomment this line and remove the next two lines when icon is deprecated
    , (0, _extends2.default)({}, sanitize(textInputPassthroughProps, null, 'icon'), {
      "data-tid": "ba-common-textinput-section__textinput",
      "aria-labelledby": this._propLabelId,
      textDir: textDir
    }, inputProps, {
      className: "textInputSection",
      light: light != null ? light : true
    })));
  }
}
exports["default"] = TextInputSection;
(0, _defineProperty2.default)(TextInputSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  textAlign: _propTypes.default.oneOf(['left', 'right']),
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  fireOnBlur: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._textinput.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(TextInputSection, "defaultProps", {
  textAlign: 'left',
  className: '',
  style: {}
});

/***/ }),

/***/ 37955:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _truncatedtext = _interopRequireDefault(__webpack_require__(47511));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _SectionStyles = _interopRequireDefault(__webpack_require__(3197));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const textSectionClassName = _SectionStyles.default.textSectionClassName.replace(/"/g, '');
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
const {
  omit
} = _utils.lodash;
class TextSection extends _react.Component {
  render() {
    const {
      label,
      title,
      text,
      disabled,
      readOnly,
      rtl,
      labelSize,
      textAlign,
      className,
      style,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(textSectionClassName, rtl);
    const {
      propertiesPanePassthroughProps,
      others: truncatedTextPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, TextSection), propertiesPanePassthroughProps, {
      className: `${classNames} ${className}`,
      label: label,
      title: title,
      rtl: rtl,
      labelSize: labelSize,
      disabled: disabled,
      style: style
    }), /*#__PURE__*/_react.default.createElement("div", {
      "data-tid": "ba-common-text-section__truncated-text",
      className: (0, _utils.classnames)({
        disabled: disabled || readOnly
      })
    }, /*#__PURE__*/_react.default.createElement(_truncatedtext.default, (0, _extends2.default)({}, truncatedTextPassthroughProps, {
      value: text,
      textAlign: textAlign
    }))));
  }
}
exports["default"] = TextSection;
(0, _defineProperty2.default)(TextSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  text: _propTypes.default.string.isRequired,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  resizable: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  truncateFullCount: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ...omit(_truncatedtext.default.propTypes, 'value'),
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(TextSection, "defaultProps", {
  truncateFullCount: false,
  className: '',
  style: {}
});

/***/ }),

/***/ 53784:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _toggleswitch = _interopRequireDefault(__webpack_require__(58083));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _tooltip = _interopRequireDefault(__webpack_require__(65391));
var _information_ = _interopRequireDefault(__webpack_require__(21149));
var _PropertiesPane = _interopRequireDefault(__webpack_require__(64562));
var _Container = _interopRequireDefault(__webpack_require__(65735));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
class ToggleSwitchSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__toggleSwitchSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }
  render() {
    const {
      label,
      title,
      checked,
      disabled,
      readOnly,
      rtl,
      onChange,
      className,
      style,
      small,
      tooltipText,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: toggleSwitchPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, ToggleSwitchSection), propertiesPanePassthroughProps, {
      className: className,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), tooltipText && /*#__PURE__*/_react.default.createElement(_Container.default, {
      style: {
        position: 'absolute',
        right: 0,
        top: '0.25rem'
      }
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: tooltipText,
      orient: "left"
    }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      icon: _information_.default.id
    }))), /*#__PURE__*/_react.default.createElement(_toggleswitch.default, (0, _extends2.default)({}, toggleSwitchPassthroughProps, {
      id: this._id,
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-toggleswitch-section__toggleswitch",
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      small: small != null ? small : true
    })));
  }
}
exports["default"] = ToggleSwitchSection;
(0, _defineProperty2.default)(ToggleSwitchSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._toggleswitch.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(ToggleSwitchSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 21946:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-container.react-resizable svg.resize-handler-icon:focus{outline:2px solid #a8c0f3}.ba-common-container.react-resizable{position:relative}.ba-common-container.react-resizable svg.resize-handler-icon{position:absolute;margin:auto;display:block;z-index:2}.ba-common-container.react-resizable .react-resizable-handle{background-color:#eaeaea;box-sizing:border-box;position:absolute;margin:auto}@media screen and (-ms-high-contrast: active){.ba-common-container.react-resizable .react-resizable-handle{border:1px solid #fff}}.ba-common-container.react-resizable.is-x{padding-right:8px;height:100% !important}.ba-common-container.react-resizable.is-x svg.resize-handler-icon-e{width:8px;top:0;bottom:0;right:0}.ba-common-container.react-resizable.is-x svg.resize-handler-icon-w{width:8px;top:0;bottom:0;left:0}.ba-common-container.react-resizable.is-x .react-resizable-handle-e{width:8px;height:100%;top:0;bottom:0;right:0;cursor:col-resize}.ba-common-container.react-resizable.is-x .react-resizable-handle-w{width:8px;height:100%;top:0;bottom:0;left:0;cursor:col-resize}.ba-common-container.react-resizable.is-y{padding-bottom:8px;width:100% !important}.ba-common-container.react-resizable.is-y svg.resize-handler-icon-s{height:16px;left:50%;bottom:-4px;transform:rotate(90deg)}.ba-common-container.react-resizable.is-y svg.resize-handler-icon-n{height:16px;left:50%;top:-4px;transform:rotate(90deg)}.ba-common-container.react-resizable.is-y .react-resizable-handle-n{height:8px;width:100%;top:0;right:0;left:0;cursor:row-resize}.ba-common-container.react-resizable.is-y .react-resizable-handle-s{height:8px;width:100%;bottom:0;right:0;left:0;cursor:row-resize}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-se{width:16px;height:16px;right:0;bottom:0}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-sw{width:16px;height:16px;bottom:0px;left:0px}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-nw{width:16px;height:16px;top:0px;left:0px}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-ne{width:16px;height:16px;top:0px;right:0px}.ba-common-container.react-resizable.is-both .react-resizable-handle-se{width:16px;height:16px;bottom:0;right:0;cursor:se-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-sw{width:16px;height:16px;bottom:0px;left:0px;cursor:sw-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-ne{width:16px;height:16px;top:0px;right:0px;cursor:ne-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-nw{width:16px;height:16px;top:0px;left:0px;cursor:nw-resize}", ""]);

// exports
exports.locals = {
	"containerClassName": "\"ba-common-container\""
};

/***/ }),

/***/ 41109:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".tooltip-position{position:absolute;right:0;top:.8rem}.ba-common-collapsibleSection .is-large .ba-common-propertiesPane__children{justify-content:flex-end}.ba-common-propertiesPane{min-height:40px;position:relative}.ba-common-propertiesPane__inner{display:grid;width:100%;grid-gap:8px;grid-template-areas:\"ba-common-propertiesPane__label ba-common-propertiesPane__children\";grid-template-columns:1fr 1fr 1fr 1fr;-ms-grid-template-columns:1fr 8px 1fr 8px 1fr 8px 1fr}.ba-common-propertiesPane__inner.is-column{grid-gap:0;grid-template-columns:none;-ms-grid-columns:1fr;grid-template-areas:\"ba-common-propertiesPane__label\" \"ba-common-propertiesPane__children\";-ms-grid-template-rows:1fr 1fr}.ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__label{justify-content:flex-start;-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__children{justify-content:flex-start;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__label{grid-column:1/2;-ms-grid-column:1;-ms-grid-column-span:1}.ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__children{grid-column:2/5;-ms-grid-column:2;-ms-grid-column-span:3}.ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__label{grid-column:1/3;-ms-grid-column:1;-ms-grid-column-span:2}.ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__children{grid-column:3/5;-ms-grid-column:3;-ms-grid-column-span:2}.ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__label{grid-column:1/4;-ms-grid-column:1;-ms-grid-column-span:3}.ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__children{grid-column:4/5;-ms-grid-column:4;-ms-grid-column-span:1}.ba-common-propertiesPane__inner .ba-common-propertiesPane__label{display:flex;flex-direction:column}.ba-common-propertiesPane__inner .ba-common-propertiesPane__children{display:flex;align-items:center;justify-content:flex-start}.ba-common-propertiesPane__inner .ba-common-propertiesPane__children.is-flexEnd{justify-content:flex-end}.ba-common-propertiesPane__inner .ba-common-button:not(.is-disabled) *:hover{cursor:pointer}.ba-common-propertiesPane__inner .ba-common-button.is-disabled *:hover{cursor:not-allowed}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner .ba-common-propertiesPane__children{grid-row:1;justify-content:flex-start}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column{grid-template-columns:none;-ms-grid-columns:1fr;grid-template-areas:\"ba-common-propertiesPane__label\" \"ba-common-propertiesPane__children\";-ms-grid-template-rows:1fr 1fr}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__label{grid-row:1;justify-content:flex-end;-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__children{grid-row:2;justify-content:flex-end;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__label{grid-column:4/5;-ms-grid-column:4;-ms-grid-column-span:1}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__children{grid-column:1/4;-ms-grid-column:1;-ms-grid-column-span:3}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__label{grid-column:3/5;-ms-grid-column:3;-ms-grid-column-span:2}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__children{grid-column:1/3;-ms-grid-column:1;-ms-grid-column-span:2}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__label{grid-column:2/5;-ms-grid-column:2;-ms-grid-column-span:3}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__children{grid-column:1/2;-ms-grid-column:1;-ms-grid-column-span:1}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner .ba-common-propertiesPane__iconPosition{margin-left:8px;margin-right:0px}.ba-common-propertiesPane__iconPosition{margin-right:8px;margin-left:0px;align-items:center}.ba-common-propertiesPane__iconPosition .ba-common-propertiesPane__icon{height:32px}.ba-common-propertiesPane__labelContent{display:flex;flex-direction:row;min-height:40px;align-items:center;justify-content:flex-start}.ba-common-propertiesPane__labelContent.is-rtl{flex-direction:row-reverse}.ba-common-propertiesPane__labelContent .ba-common-label{line-height:20px}.ba-common-propertiesPane__labelContent>*{margin-right:8px}.ba--highContrast .ba-common-propertiesPane.is-header{outline:1px inset transparent}.ba-common-propertiesPane{transition:color .2s ease-in-out;background-color:#fff}.ba-common-propertiesPane.is-header{color:#1f57a4;background-color:#f6f6f6}.ba-common-propertiesPane__icon{transition:opacity .2s ease-in-out}.ba-common-propertiesPane__icon.is-disabled{opacity:.5}", ""]);

// exports
exports.locals = {
	"propertiesPaneClassName": "\"ba-common-propertiesPane\""
};

/***/ }),

/***/ 82660:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-propertyPanel{font-size:14px;display:flex;flex-direction:column;background:#fff;min-width:400px;padding:0 24px;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.1)}.ba-common-propertyPanel__panelTitle{line-height:48px;width:100%;font-weight:600;vertical-align:middle}.ba-common-propertyPanel .ba-common-tabList{height:40px;margin-bottom:24px}.ba-common-propertyPanel .ba-common-tabList__inner{padding:0}.ba-common-propertyPanel__buttonSection{display:flex;height:64px;align-items:center;flex-direction:row-reverse}.ba-common-propertyPanel__buttonSection__rightButton{align-self:flex-end}", ""]);

// exports
exports.locals = {
	"propertyPanelClassName": "\"ba-common-propertyPanel\""
};

/***/ }),

/***/ 8047:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-labelSection{display:flex;align-items:center;min-height:40px;width:100%}.ba-common-labelSection .ba-common-label{font-weight:600}.ba-common-labelSection.is-sectionHeader .ba-common-label{font-weight:600}.ba-common-labelSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-labelSection .ba-common-truncatedText{text-align:right}.ba-common-textInputSection{text-align:left !important}.ba-common-textInputSection .ba-common-baseInput{height:32px}.ba-common-textInputSection .ba-common-baseInput input{height:32px}.ba-common-numberSection{text-align:left !important}.ba-common-numberSection .ba-common-baseInput{height:32px}.ba-common-numberSection .ba-common-baseInput input{height:32px}.ba-common-checkboxSection .ba-common-checkbox.is-right input{right:0}.ba-common-checkboxSection .ba-common-checkbox__box{margin-top:-2px}.ba-common-selectSection .ba-common-select{width:100%}.ba-common-selectSection .ba-common-select__wrapper{width:100%}.ba-common-selectSection .ba-common-select .ba-common-button{min-width:0}.ba-common-selectSection .ba-common-select .ba-common-toolTip{display:block !important}.ba-common-selectSection .ba-common-select .ba-common-truncatedText__text{line-height:20px}.ba-common-selectSection .ba-common-select .ba-common-selectGroup{width:100%}.ba-common-selectSection .ba-common-selectGroup{padding:4px 0;width:100%}.ba-common-linkSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-linkSection .ba-common-truncatedText{text-align:right}.ba-common-textAreaSection .ba-common-textArea>textarea{margin-top:0}.ba-common-comboboxSection .ba-common-combobox{min-width:80px !important;width:100% !important;height:32px}.ba-common-comboboxSection .ba-common-combobox .ba-common-baseInput{width:100%;border-left:0;border-right:0;height:32px}.ba-common-comboboxSection .ba-common-combobox .ba-common-baseInput input{height:32px}.ba-common-collapsibleSection .ba-common-propertiesPane:first-child{padding-top:0}.ba-common-collapsibleSection .ba-common-propertiesPane .ba-common-button:first-of-type{padding:0 8px}.ba-common-collapsibleSection__trigger-button{color:inherit;margin-right:0px;margin-top:4px;min-width:100%}.ba-common-collapsibleSection__trigger-button:hover{color:inherit}.ba-common-collapsibleSection__trigger-button.bx--btn--ghost.bx--btn--field{outline:none;padding-left:0px}.ba-common-radioSection .ba-radioGroup.is-vertical.is-right{align-items:flex-end}.ba-common-radioSection .ba-radioGroup.is-vertical.is-left{align-items:flex-start}.ba-common-radioSection .ba-radioGroup__item .ba-radio{flex-direction:row}.ba-common-radioSection .ba-radioGroup__item .ba-radio.is-left .ba-radio__label{padding-left:8px;padding-right:0}.ba-common-radioSection .ba-radioGroup__item .ba-radio.is-right .ba-radio__label{padding-right:8px;padding-left:0}.ba-common-textSection{height:20px}.ba-common-textSection .ba-common-truncatedText{text-align:right}.ba-common-textSection .ba-common-truncatedText__text{line-height:20px}.ba-common-textSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-combobox__wrapper .ba-common-combobox__icon{transition:none;color:#595859}.ba-common-textSection.is-disabled .ba-common-truncatedText{opacity:1}.ba-common-textSection.is-disabled .ba-common-truncatedText__text{opacity:.5}", ""]);

// exports
exports.locals = {
	"labelSectionClassName": "\"ba-common-labelSection\"",
	"textInputSectionClassName": "\"ba-common-textInputSection\"",
	"selectSectionClassName": "\"ba-common-selectSection\"",
	"textAreaSectionClassName": "\"ba-common-textAreaSection\"",
	"collapsibleSectionClassName": "\"ba-common-collapsibleSection\"",
	"radioSectionClassName": "\"ba-common-radioSection\"",
	"textSectionClassName": "\"ba-common-textSection\"",
	"checkboxSectionClassName": "\"ba-common-checkboxSection\"",
	"linkSectionClassName": "\"ba-common-linkSection\"",
	"comboboxSectionClassName": "\"ba-common-comboboxSection\"",
	"numberInputSectionClassName": "\"ba-common-numberSection\""
};

/***/ }),

/***/ 11608:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21946);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Container_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 71379:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41109);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 35486:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82660);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 3197:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8047);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 37592:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--right_32");

/***/ }),

/***/ 68946:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--right_32.js");

/***/ }),

/***/ 21149:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/information_16");

/***/ }),

/***/ 3591:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/resize-panel_24");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 95103:
/***/ ((module) => {

"use strict";
module.exports = require("react-resizable");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 28432:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__28432__;

/***/ }),

/***/ 48477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__48477__;

/***/ }),

/***/ 56006:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56006__;

/***/ }),

/***/ 32299:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32299__;

/***/ }),

/***/ 37394:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__37394__;

/***/ }),

/***/ 11880:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__11880__;

/***/ }),

/***/ 46061:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__46061__;

/***/ }),

/***/ 16414:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__16414__;

/***/ }),

/***/ 15294:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__15294__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 90230:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__90230__;

/***/ }),

/***/ 73346:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__73346__;

/***/ }),

/***/ 58083:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__58083__;

/***/ }),

/***/ 65391:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__65391__;

/***/ }),

/***/ 47511:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__47511__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(50339));
/******/ return __webpack_exports__;
/******/ }
]);
});